import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'selector',
    'addBtn',
    'iconPlus',
    'iconClose',
    'btnText',
    'search',
    'filterAll',
    'filterLive',
    'filterQueued',
    'filterDisabled',
    'table',
    'row',
    'mobileList',
    'mobileCard',
    'editModal',
    'editModalContent'
  ]

  connect() {
    this.currentFilter = 'all'
  }

  toggleSelector() {
    if (!this.hasSelectorTarget) return

    const isHidden = this.selectorTarget.classList.toggle('hidden')

    if (this.hasIconPlusTarget && this.hasIconCloseTarget && this.hasBtnTextTarget && this.hasAddBtnTarget) {
      if (!isHidden) {
        // Showing selector
        this.iconPlusTarget.classList.add('hidden')
        this.iconCloseTarget.classList.remove('hidden')
        this.btnTextTarget.textContent = 'Close'
        this.addBtnTarget.classList.remove('btn-primary')
        this.addBtnTarget.classList.add('btn-secondary')
      } else {
        // Hiding selector
        this.iconPlusTarget.classList.remove('hidden')
        this.iconCloseTarget.classList.add('hidden')
        this.btnTextTarget.textContent = 'Add Locations'
        this.addBtnTarget.classList.add('btn-primary')
        this.addBtnTarget.classList.remove('btn-secondary')
      }
    }
  }

  filterTable() {
    const searchTerm = this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ''
    this.applyFilters(searchTerm, this.currentFilter)
  }

  setStatusFilter(event) {
    const filter = event.currentTarget.dataset.filter
    this.currentFilter = filter

    // Update active state on filter pills
    const pills = [
      this.filterAllTarget,
      this.filterLiveTarget,
      this.filterQueuedTarget,
      this.filterDisabledTarget
    ].filter(Boolean)

    pills.forEach((pill) => {
      if (pill.dataset.filter === filter) {
        pill.classList.add('active')
      } else {
        pill.classList.remove('active')
      }
    })

    // Apply filters
    const searchTerm = this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ''
    this.applyFilters(searchTerm, filter)
  }

  applyFilters(searchTerm, statusFilter) {
    // Filter desktop table rows
    if (this.hasRowTarget) {
      this.rowTargets.forEach((row) => {
        const city = row.dataset.city || ''
        const state = row.dataset.state || ''
        const status = row.dataset.status || ''

        const matchesSearch = !searchTerm ||
          city.includes(searchTerm) ||
          state.includes(searchTerm)

        const matchesStatus = statusFilter === 'all' || status === statusFilter

        if (matchesSearch && matchesStatus) {
          row.classList.remove('hidden')
        } else {
          row.classList.add('hidden')
        }
      })
    }

    // Filter mobile cards
    if (this.hasMobileCardTarget) {
      this.mobileCardTargets.forEach((card) => {
        const city = card.dataset.city || ''
        const state = card.dataset.state || ''
        const status = card.dataset.status || ''

        const matchesSearch = !searchTerm ||
          city.includes(searchTerm) ||
          state.includes(searchTerm)

        const matchesStatus = statusFilter === 'all' || status === statusFilter

        if (matchesSearch && matchesStatus) {
          card.classList.remove('hidden')
        } else {
          card.classList.add('hidden')
        }
      })
    }
  }

  editArea(event) {
    const areaId = event.currentTarget.dataset.areaId
    if (!areaId) return

    // For now, show a simple loading state and fetch edit form
    // In production, this would fetch the edit form via AJAX
    this.showEditModal(areaId)
  }

  showEditModal(areaId) {
    if (!this.hasEditModalTarget || !this.hasEditModalContentTarget) return

    // Show modal with loading state
    this.editModalTarget.classList.remove('hidden')
    this.editModalContentTarget.innerHTML = `
      <div class="text-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 mx-auto mb-4" style="border-color: var(--color-primary);"></div>
        <p style="color: var(--text-secondary);">Loading...</p>
      </div>
    `

    // Fetch the edit form via AJAX
    const url = window.location.pathname.replace('/service_areas', `/service_areas/${areaId}/edit`)

    fetch(url, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load')
        return response.text()
      })
      .then((html) => {
        this.editModalContentTarget.innerHTML = html
      })
      .catch((error) => {
        console.error('Edit modal error:', error)
        this.editModalContentTarget.innerHTML = `
          <div class="text-center py-8">
            <p style="color: var(--color-error);">Failed to load edit form</p>
            <button type="button" class="btn btn-ghost btn-sm mt-4" data-action="click->service-areas-filter#closeEditModal">Close</button>
          </div>
        `
      })
  }

  closeEditModal() {
    if (this.hasEditModalTarget) {
      this.editModalTarget.classList.add('hidden')
    }
  }
}
